/* Estado do login, compartilhado pelo app. A fonte da verdade é a API (/api/auth/session):
   os tokens ficam em cookies HttpOnly que o JavaScript não lê. */
import { useSyncExternalStore } from 'react';
import type { AuthState } from '@jarvis/shared';
import { api } from './api';

export type AuthSnapshot =
  | { phase: 'checking' }
  | { phase: 'ready'; state: AuthState }
  | { phase: 'unreachable'; message: string };

let snap: AuthSnapshot = { phase: 'checking' };
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
let inflight: Promise<void> | null = null;

export const authStore = {
  get: () => snap,
  set(state: AuthState) { snap = { phase: 'ready', state }; emit(); },
  refresh(): Promise<void> {
    inflight ??= api.get<AuthState>('/api/auth/session')
      .then((state) => { snap = { phase: 'ready', state }; })
      .catch((e: Error) => { snap = { phase: 'unreachable', message: e.message }; })
      .finally(() => { inflight = null; emit(); });
    return inflight;
  },
  subscribe(l: () => void) { listeners.add(l); return () => { listeners.delete(l); }; }
};

export function useAuth(): AuthSnapshot {
  return useSyncExternalStore(authStore.subscribe, authStore.get);
}
